export default __webpack_public_path__ + "navigation-examples-beta-query-parameters-1200-ba129c8f17c4178c5bb835db78526740.png";